import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'  // svg组件
Vue.component('SvgIcon', SvgIcon)  // 全局组件
const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/)
let result = requireAll(req)



// WEBPACK FOOTER //
// ./src/assets/icons/index.js